import SearchIcon from '@mui/icons-material/Search';
import { List, ListItem, TextField } from '@mui/material';
import React, { MutableRefObject } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { darkGray } from '../../../../../theme/color-constants';

export const StyledList = styled(List)<{ $backgroundColor: string }>`
  padding: 0px !important;
  background-color: ${(props) => props.$backgroundColor};
`;

export const StyledTextField = styled(TextField)`
  & .MuiInput-root:before {
    border-bottom: 1px solid white;
  }
  & .MuiInput-underline:after {
    border-bottom: 1px solid white;
  }
`;

interface FilterSearchProps {
  setGlobalSearchText: (r: string) => void;
  startTransition: (r: () => void) => void;
  globalSearchRef: MutableRefObject<HTMLInputElement | undefined>;
}

export const FilterSearch = (props: FilterSearchProps) => {
  const { setGlobalSearchText, startTransition, globalSearchRef } = props;
  const { t } = useTranslation();

  return (
    <StyledList $backgroundColor={darkGray} dense>
      <ListItem sx={{ cursor: 'pointer' }}>
        <StyledTextField
          inputRef={globalSearchRef}
          label={t('common:filterTray.searchAllFilterValues')}
          fullWidth
          onChange={(e) => {
            startTransition(() => {
              setGlobalSearchText(e.target.value);
            });
          }}
          autoComplete="off"
          InputProps={{
            startAdornment: <SearchIcon sx={{ color: 'white' }} />,
            sx: { color: 'white' },
          }}
          sx={{ color: 'white' }}
          color="secondary"
        />
      </ListItem>
    </StyledList>
  );
};
